import React from 'react'

const Grades = () => {
  return (
    <div>Grades</div>
  )
}

export default Grades